export default __webpack_public_path__ + "static/underline-24-mobile-cb74cd3702d2d455946cdc60e7a0da48.svg";